export default "__VITE_ASSET__BFqYRKiP__"